__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.6.2-5ec6ae8-11859/_next/";